"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ArrowNarrowLeft: function() {
        return ArrowNarrowLeft;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ArrowNarrowLeft = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L3.29289 11.2929C3.10536 11.4804 3 11.7348 3 12C3 12.2652 3.10536 12.5196 3.29289 12.7071L7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071C9.09763 16.3166 9.09763 15.6834 8.70711 15.2929L6.41422 13L20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11L6.41421 11L8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289Z",
        fill: "currentColor"
    })
}), "ArrowNarrowLeft");
const _default = ArrowNarrowLeft;
